// ─── MOSTRAR / OCULTAR CONTRASEÑA ─────────────────────────────
// Botón con ícono de ojo que alterna el campo entre password y texto.
// Funciona para cualquier botón [data-password-toggle="idDelInput"].
(() => {
  "use strict";

  document.querySelectorAll("[data-password-toggle]").forEach((btn) => {
    const input = document.getElementById(btn.dataset.passwordToggle);
    if (!input) return;

    btn.addEventListener("click", () => {
      const mostrar = input.type === "password";
      input.type = mostrar ? "text" : "password";
      btn.classList.toggle("is-visible", mostrar);
      btn.setAttribute("aria-pressed", String(mostrar));
      btn.setAttribute("aria-label", mostrar ? "Ocultar contraseña" : "Mostrar contraseña");
      input.focus();
    });
  });
})();
